import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import NavigationService from '@disco/state-management/NavigationService'
import { useRouterSync } from './useRouterSync'

interface RouterProviderProps {
  children: React.ReactNode
}

/**
 * Component that initializes the NavigationService with the navigate function
 * and syncs router state with Redux. Should be placed inside BrowserRouter
 * but outside of any Routes.
 */
export const RouterProvider: React.FC<RouterProviderProps> = ({ children }) => {
  const navigate = useNavigate()

  // Initialize NavigationService
  useEffect(() => {
    NavigationService.setNavigate(navigate)
  }, [navigate])

  // Sync router location with Redux state
  useRouterSync()

  return <>{children}</>
}
